// Feedback API Service
// Configuration - Change this URL for production deployment
const API_BASE_URL = process.env.REACT_APP_API_URL;

class FeedbackService {
  
  // Submit feedback to backend
  async submitFeedback(feedbackData) {
    try {
      const apiUrl = `${API_BASE_URL}/feedbacks`;
      
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            page_url: feedbackData.pageUrl,
            page_title: feedbackData.pageTitle || document.title,
            feedback_type: feedbackData.type, // 'positive' or 'negative'
            feedback_text: feedbackData.text || null,
            session_id: this.getSessionId()
          }
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const result = await response.json();
      return result;
      
    } catch (error) {
      console.error('Error submitting feedback:', error);
      throw error;
    }
  }

  // Get feedback analytics for a specific page
  async getPageAnalytics(pageUrl) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/feedback/analytics?page_url=${encodeURIComponent(pageUrl)}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result.data;
      
    } catch (error) {
      console.error('Error fetching page analytics:', error);
      throw error;
    }
  }

  // Get overall analytics
  async getOverallAnalytics() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/feedback/analytics`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result.data;
      
    } catch (error) {
      console.error('Error fetching overall analytics:', error);
      throw error;
    }
  }

  // Get page-wise analytics
  async getPageWiseAnalytics() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/feedback/page-analytics`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result.data;
      
    } catch (error) {
      console.error('Error fetching page-wise analytics:', error);
      throw error;
    }
  }

  // Generate or get session ID
  getSessionId() {
    let sessionId = sessionStorage.getItem('user_session_id');
    if (!sessionId) {
      sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem('user_session_id', sessionId);
    }
    return sessionId;
  }

  // Submit positive feedback (Yes button)
  async submitPositiveFeedback(pageUrl, pageTitle) {
    return this.submitFeedback({
      pageUrl,
      pageTitle,
      type: 'positive'
    });
  }

  // Submit negative feedback (No button with text)
  async submitNegativeFeedback(pageUrl, pageTitle, feedbackText) {
    return this.submitFeedback({
      pageUrl,
      pageTitle,
      type: 'negative',
      text: feedbackText
    });
  }
}

const feedbackService = new FeedbackService();
export default feedbackService;